import React, { useEffect } from "react";

const GloblePopup = ({ isOpen, onClose, title, children, className,isFlag }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.classList.add("popupopened");
        } else {
            document.body.classList.remove("popupopened");
        }
        return () => {
            document.body.classList.remove("popupopened");
        };
    }, [isOpen]);
    // if (!isOpen) return null;
    return (
        <>
            <div className={`modal ${className} ${ isOpen? 'open' : ''}`}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{title}</h5>
                            <button type="button" className="close" onClick={onClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GloblePopup;
